import { useState } from "react";
import "../styles/TrainingApp.css";

const TrainingApp = () => {
  const [step, setStep] = useState(1); // 1: Home, 2: Create User, 3: VR Complete, 4: Quiz, 5: Print
  const [user, setUser] = useState(null);
  const [barcode, setBarcode] = useState("");
  const [quizAnswers, setQuizAnswers] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [loadingMessage, setLoadingMessage] = useState("");
  const [language, setLanguage] = useState("de");
  const [newUser, setNewUser] = useState({
    name: "",
    basfId: "",
    dob: "",
    address: "",
    department: "",
    role: "",
  });

  // Default user data for David Heckmann
  const defaultUser = {
    id: "BASF54321",
    name: "David Heckmann",
    dob: "14.04.1990",
    address: "Heinigstraße 31, 67059 Ludwigshafen am Rhein",
    department: "Safety",
    role: "Sub-contractor",
  };

  const fakeUsers = [
    { id: "BASF12345", name: "Anna Schmidt", dob: "1985-03-15", address: "Ludwigshafen, DE", department: "Chemieproduktion", role: "Technikerin" },
    { id: "BASF67890", name: "Lukas Müller", dob: "1990-07-22", address: "Mannheim, DE", department: "Sicherheitsmanagement", role: "Sicherheitsbeauftragter" },
    { id: "BASF11223", name: "Sophie Wagner", dob: "1992-11-30", address: "Heidelberg, DE", department: "Logistik", role: "Fachkraft" },
    defaultUser,
  ];

  const languages = [
    { code: "de", name: "Deutsch" }, { code: "en", name: "English" }, { code: "fr", name: "Français" }, { code: "es", name: "Español" },
    { code: "it", name: "Italiano" }, { code: "pt", name: "Português" }, { code: "nl", name: "Nederlands" }, { code: "sv", name: "Svenska" },
    { code: "no", name: "Norsk" }, { code: "da", name: "Dansk" }, { code: "fi", name: "Suomi" }, { code: "pl", name: "Polski" },
    { code: "cs", name: "Čeština" }, { code: "sk", name: "Slovenčina" }, { code: "hu", name: "Magyar" }, { code: "ro", name: "Română" },
    { code: "bg", name: "Български" }, { code: "el", name: "Ελληνικά" }, { code: "tr", name: "Türkçe" }, { code: "ru", name: "Русский" },
    { code: "uk", name: "Українська" }, { code: "hr", name: "Hrvatski" }, { code: "sr", name: "Српски" }, { code: "sl", name: "Slovenščina" },
    { code: "et", name: "Eesti" }, { code: "lv", name: "Latviešu" }, { code: "lt", name: "Lietuvių" }, { code: "ga", name: "Gaelige" },
    { code: "mt", name: "Malti" }, { code: "ar", name: "العربية" }, { code: "he", name: "עברית" }, { code: "fa", name: "فارسی" },
    { code: "hi", name: "हिन्दी" }, { code: "bn", name: "বাংলা" }, { code: "ta", name: "தமிழ்" }, { code: "te", name: "తెలుగు" },
    { code: "ml", name: "മലയാളം" }, { code: "kn", name: "ಕನ್ನಡ" }, { code: "gu", name: "ગુજરાતી" }, { code: "pa", name: "ਪੰਜਾਬੀ" },
    { code: "mr", name: "मराठी" }, { code: "ur", name: "اردو" }, { code: "th", name: "ไทย" }, { code: "vi", name: "Tiếng Việt" },
    { code: "id", name: "Bahasa Indonesia" }, { code: "ms", name: "Bahasa Melayu" }, { code: "fil", name: "Filipino" }, { code: "zh", name: "中文" },
    { code: "ja", name: "日本語" }, { code: "ko", name: "한국어" }, { code: "mn", name: "Монгол" }, { code: "km", name: "ខ្មែរ" },
    { code: "lo", name: "ລາວ" }, { code: "my", name: "မြန်မာ" }, { code: "si", name: "සිංහල" }, { code: "ne", name: "नेपाली" },
    { code: "dz", name: "ཇོང་ཁ" }, { code: "am", name: "አማርኛ" }, { code: "ti", name: "ትግርኛ" }, { code: "so", name: "Soomaali" },
    { code: "sw", name: "Kiswahili" }, { code: "ha", name: "Hausa" }, { code: "yo", name: "Yorùbá" }, { code: "ig", name: "Igbo" },
    { code: "zu", name: "isiZulu" }, { code: "xh", name: "isiXhosa" }, { code: "af", name: "Afrikaans" }, { code: "sq", name: "Shqip" },
    { code: "hy", name: "Հայերեն" }, { code: "az", name: "Azərbaycan" }, { code: "eu", name: "Euskara" }, { code: "be", name: "Беларуская" },
    { code: "bs", name: "Bosanski" }, { code: "ka", name: "ქართული" }, { code: "gl", name: "Galego" }, { code: "is", name: "Íslenska" },
    { code: "mk", name: "Македонски" }, { code: "ky", name: "Кыргызча" }, { code: "kk", name: "Қазақ" }, { code: "tg", name: "Тоҷикӣ" },
    { code: "uz", name: "Oʻzbek" }, { code: "tt", name: "Татар" }, { code: "tk", name: "Türkmen" }, { code: "ps", name: "پښتو" },
    { code: "sd", name: "سنڌي" }, { code: "ku", name: "Kurdî" }, { code: "la", name: "Latina" }, { code: "eo", name: "Esperanto" },
    { code: "sm", name: "Gagana Samoa" }, { code: "to", name: "Lea Faka-Tonga" }, { code: "haw", name: "ʻŌlelo Hawaiʻi" }, { code: "mg", name: "Malagasy" },
    { code: "ny", name: "Chichewa" }, { code: "st", name: "Sesotho" }, { code: "sn", name: "Shona" }, { code: "ts", name: "Xitsonga" },
  ];

  const questions = [
    {
      id: 1,
      text: language === "de" ? "Was ist der erste Schritt im Falle eines Brandes?" : "What is the first step in case of a fire?",
      options: language === "de" ? [
        "Ruhe bewahren und Fluchtweg suchen",
        "Feuerlöscher holen",
        "Kollegen informieren",
        "Fenster öffnen",
      ] : [
        "Stay calm and find an escape route",
        "Get a fire extinguisher",
        "Inform colleagues",
        "Open a window",
      ],
      correct: language === "de" ? "Ruhe bewahren und Fluchtweg suchen" : "Stay calm and find an escape route",
    },
    {
      id: 2,
      text: language === "de" ? "Welche persönliche Schutzausrüstung (PSA) ist bei Arbeiten mit Chemikalien erforderlich?" : "Which personal protective equipment (PPE) is required when working with chemicals?",
      options: language === "de" ? [
        "Schutzbrille und Handschuhe",
        "Nur Schutzbrille",
        "Nur Handschuhe",
        "Keine PSA nötig",
      ] : [
        "Safety goggles and gloves",
        "Only safety goggles",
        "Only gloves",
        "No PPE required",
      ],
      correct: language === "de" ? "Schutzbrille und Handschuhe" : "Safety goggles and gloves",
    },
    {
      id: 3,
      text: language === "de" ? "Wie verhalten Sie sich bei einem Explosionsalarm?" : "How do you behave during an explosion alarm?",
      options: language === "de" ? [
        "Sofort den nächsten Fluchtweg nutzen",
        "Arbeitsplatz absichern",
        "Alarm ignorieren",
        "Vorgesetzten anrufen",
      ] : [
        "Immediately use the nearest escape route",
        "Secure the workplace",
        "Ignore the alarm",
        "Call the supervisor",
      ],
      correct: language === "de" ? "Sofort den nächsten Fluchtweg nutzen" : "Immediately use the nearest escape route",
    },
  ];

  const progressSteps = [
    {
      id: 1,
      name: language === "de" ? "Benutzerdaten" : "User Data",
      description: language === "de" ? "Geben Sie Ihre BASF-ID ein oder scannen Sie sie." : "Enter or scan your BASF ID.",
      icon: "/user_data.png",
      active: [1, 2],
    },
    {
      id: 2,
      name: language === "de" ? "VR-Training" : "VR Training",
      description: language === "de" ? "Tragen Sie die VR-Brille und absolvieren Sie das Training." : "Wear the VR glasses and complete the training.",
      icon: "/vr.png",
      active: [3],
    },
    {
      id: 3,
      name: language === "de" ? "Quiz" : "Test",
      description: language === "de" ? "Beantworten Sie die Sicherheitsfragen." : "Answer the safety questions.",
      icon: "/test.png",
      active: [4],
    },
    {
      id: 4,
      name: language === "de" ? "Abzeichen drucken" : "Print Badge",
      description: language === "de" ? "Drucken Sie Ihr Abschlussabzeichen." : "Print your completion badge.",
      icon: "/print.png",
      active: [5],
    },
  ];

  const handleBarcodeSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true);
    setLoadingMessage(language === "de" ? "Benutzer wird gesucht..." : "Searching for user...");
    setTimeout(() => {
      setUser(defaultUser);
      setStep(1);
      setIsLoading(false);
      setBarcode("");
    }, 2000);
  };

  const handleCameraScan = () => {
    setIsLoading(true);
    setLoadingMessage(language === "de" ? "Barcode wird gescannt..." : "Scanning barcode...");
    setTimeout(() => {
      setUser(defaultUser);
      setStep(1);
      setIsLoading(false);
    }, 2000);
  };

  const handleNewUserSubmit = (e) => {
    e.preventDefault();
    if (!newUser.name || !newUser.basfId) {
      alert(language === "de" ? "Name und BASF-ID sind erforderlich." : "Name and BASF ID are required.");
      return;
    }
    setIsLoading(true);
    setLoadingMessage(language === "de" ? "Benutzer wird erstellt..." : "Creating user...");
    setTimeout(() => {
      const createdUser = {
        id: newUser.basfId,
        name: newUser.name,
        dob: newUser.dob || "Nicht angegeben",
        address: newUser.address || "Nicht angegeben",
        department: newUser.department || "Nicht angegeben",
        role: newUser.role || "Nicht angegeben",
      };
      setUser(createdUser);
      setStep(1);
      setIsLoading(false);
      setNewUser({ name: "", basfId: "", dob: "", address: "", department: "", role: "" });
    }, 3000);
  };

  const handleQuizAnswer = (questionId, answer) => {
    setQuizAnswers({ ...quizAnswers, [questionId]: answer });
  };

  const handleQuizSubmit = () => {
    setIsLoading(true);
    setLoadingMessage(language === "de" ? "Quiz wird überprüft..." : "Checking test...");
    setTimeout(() => {
      setStep(5);
      setIsLoading(false);
    }, 3000);
  };

  const handleVRStart = () => {
    setIsLoading(true);
    setLoadingMessage(language === "de" ? "VR-Training wird geladen..." : "Loading VR training...");
    setTimeout(() => {
      setStep(3);
      setIsLoading(false);
    }, 5000);
  };

  const handleVRComplete = () => {
    setIsLoading(true);
    setLoadingMessage(language === "de" ? "VR-Daten werden analysiert..." : "Analyzing VR data...");
    setTimeout(() => {
      setStep(4);
      setIsLoading(false);
    }, 3000);
  };

  const handlePrintBadge = () => {
    setIsLoading(true);
    setLoadingMessage(language === "de" ? "Abzeichen wird gedruckt..." : "Printing badge...");
    setTimeout(() => {
      const badgeData = {
        name: user.name,
        id: user.id,
        date: new Date().toLocaleDateString(),
        serial: `VR-${Math.floor(1000 + Math.random() * 9000)}`,
      };
      console.log("Printing badge:", badgeData);
      alert(language === "de" ? `Abzeichen wird gedruckt für ${badgeData.name} (ID: ${badgeData.serial})` : `Badge printing for ${badgeData.name} (ID: ${badgeData.serial})`);
      setIsLoading(false);
      setStep(1);
      setUser(null);
    }, 3000);
  };

  const handleBack = () => {
    if (step === 2) setStep(1);
    else if (step === 3) setStep(1);
    else if (step === 4) setStep(3);
    else if (step === 5) setStep(4);
  };

  return (
    <div className="training-app-container">
      <header className="training-header">
        <div className="logo-section">
          <img src="/logo.png" alt="Auraplan Logo" className="logo-image" />
          <span className="logo-text">{language === "de" ? "Auraplan VR-Sicherheitstraining" : "Auraplan VR Safety Training"}</span>
        </div>
        <select
          className="language-selector"
          value={language}
          onChange={(e) => setLanguage(e.target.value)}
        >
          {languages.map((lang) => (
            <option key={lang.code} value={lang.code}>{lang.name}</option>
          ))}
        </select>
      </header>
      <main className="training-main">
        <div className="content-wrapper">
          {isLoading ? (
            <div className="loading-container">
              <div className="spinner"></div>
              <p>{loadingMessage}</p>
            </div>
          ) : (
            <div className="step-container">
              {step === 1 && (
                <>
                  <h1>{language === "de" ? "Willkommen zu Ihrem Sicherheitsportal" : "Welcome to Your Safety Portal"}</h1>
                  {user ? (
                    <>
                      <div className="profile-card">
                        <h2>{language === "de" ? "Ihre Daten" : "Your Data"}</h2>
                        <p><strong>{language === "de" ? "Name" : "Name"}:</strong> {user.name}</p>
                        <p><strong>{language === "de" ? "BASF-ID" : "BASF-ID"}:</strong> {user.id}</p>
                        <p><strong>{language === "de" ? "Geburtsdatum" : "Date of Birth"}:</strong> {user.dob}</p>
                        <p><strong>{language === "de" ? "Adresse" : "Address"}:</strong> {user.address}</p>
                        <p><strong>{language === "de" ? "Abteilung" : "Department"}:</strong> {user.department}</p>
                        <p><strong>{language === "de" ? "Rolle" : "Role"}:</strong> {user.role}</p>
                      </div>
                      <p>{language === "de" ? "Bitte starten Sie das VR-Training." : "Please start the VR training."}</p>
                      <button onClick={handleVRStart} className="submit-btn">
                        {language === "de" ? "VR-Training starten" : "Start VR Training"}
                      </button>
                    </>
                  ) : (
                    <>
                      <p>{language === "de" ? "Melden Sie sich an oder erstellen Sie einen neuen Benutzer." : "Log in or create a new user."}</p>
                      <form onSubmit={handleBarcodeSubmit} className="barcode-form">
                        <input
                          type="text"
                          value={barcode}
                          onChange={(e) => setBarcode(e.target.value)}
                          placeholder={language === "de" ? "Barcode oder BASF-ID" : "Barcode or BASF-ID"}
                          className="barcode-input"
                        />
                        <div className="button-group">
                          <button type="submit" className="submit-btn">{language === "de" ? "Anmelden" : "Log In"}</button>
                          <button type="button" className="camera-btn" onClick={handleCameraScan}>
                            {language === "de" ? "Barcode scannen" : "Scan Barcode"}
                          </button>
                        </div>
                      </form>
                      <button onClick={() => setStep(2)} className="submit-btn">
                        {language === "de" ? "Neuen Benutzer erstellen" : "Create New User"}
                      </button>
                    </>
                  )}
                </>
              )}
              {step === 2 && (
                <>
                  <h1>{language === "de" ? "Neuen Benutzer erstellen" : "Create New User"}</h1>
                  <form onSubmit={handleNewUserSubmit} className="user-form">
                    <div className="input-group">
                      <label>{language === "de" ? "Name *" : "Name *"}</label>
                      <input
                        type="text"
                        value={newUser.name}
                        onChange={(e) => setNewUser({ ...newUser, name: e.target.value })}
                        placeholder={language === "de" ? "Vollständiger Name" : "Full Name"}
                        required
                      />
                    </div>
                    <div className="input-group">
                      <label>{language === "de" ? "BASF-ID *" : "BASF-ID *"}</label>
                      <input
                        type="text"
                        value={newUser.basfId}
                        onChange={(e) => setNewUser({ ...newUser, basfId: e.target.value })}
                        placeholder={language === "de" ? "z.B. BASF12345" : "e.g., BASF12345"}
                        required
                      />
                    </div>
                    <div className="input-group">
                      <label>{language === "de" ? "Geburtsdatum" : "Date of Birth"}</label>
                      <input
                        type="date"
                        value={newUser.dob}
                        onChange={(e) => setNewUser({ ...newUser, dob: e.target.value })}
                      />
                    </div>
                    <div className="input-group">
                      <label>{language === "de" ? "Adresse" : "Address"}</label>
                      <input
                        type="text"
                        value={newUser.address}
                        onChange={(e) => setNewUser({ ...newUser, address: e.target.value })}
                        placeholder={language === "de" ? "Straße, Stadt, Land" : "Street, City, Country"}
                      />
                    </div>
                    <div className="input-group">
                      <label>{language === "de" ? "Abteilung" : "Department"}</label>
                      <input
                        type="text"
                        value={newUser.department}
                        onChange={(e) => setNewUser({ ...newUser, department: e.target.value })}
                        placeholder={language === "de" ? "z.B. Chemieproduktion" : "e.g., Chemical Production"}
                      />
                    </div>
                    <div className="input-group">
                      <label>{language === "de" ? "Rolle" : "Role"}</label>
                      <input
                        type="text"
                        value={newUser.role}
                        onChange={(e) => setNewUser({ ...newUser, role: e.target.value })}
                        placeholder={language === "de" ? "z.B. Technikerin" : "e.g., Technician"}
                      />
                    </div>
                    <div className="button-group">
                      <button type="submit" className="submit-btn">{language === "de" ? "Benutzer erstellen" : "Create User"}</button>
                      <button type="button" className="back-btn" onClick={handleBack}>{language === "de" ? "Zurück" : "Back"}</button>
                    </div>
                  </form>
                </>
              )}
              {step === 3 && user && (
                <>
                  <h1>{language === "de" ? "VR-Training abschließen" : "Complete VR Training"}</h1>
                  <p>{language === "de" ? "Bitte tragen Sie die VR-Brille und absolvieren Sie das Auraplan VR-Training." : "Please wear the VR glasses and complete the Auraplan VR Training."}</p>
                  <img
                    src="vr-training.gif"
                    alt="VR Training"
                    className="vr-gif"
                  />
                  <p>{language === "de" ? "Klicken Sie unten, wenn Sie fertig sind." : "Click below when you are finished."}</p>
                  <div className="button-group">
                    <button onClick={handleVRComplete} className="submit-btn">{language === "de" ? "Ich habe das Training abgeschlossen" : "I Have Completed the Training"}</button>
                    <button onClick={handleBack} className="back-btn">{language === "de" ? "Zurück" : "Back"}</button>
                  </div>
                </>
              )}
              {step === 4 && user && (
                <>
                  <h1>{language === "de" ? "Sicherheitsquiz" : "Safety Test"}</h1>
                  <p>{language === "de" ? "Beantworten Sie die folgenden Fragen, um fortzufahren." : "Answer the following questions to proceed."}</p>
                  {questions.map((q) => (
                    <div key={q.id} className="question-card">
                      <p><strong>{q.text}</strong></p>
                      <div className="options-container">
                        {q.options.map((option) => (
                          <label key={option} className="option-label">
                            <input
                              type="radio"
                              name={`question-${q.id}`}
                              value={option}
                              checked={quizAnswers[q.id] === option}
                              onChange={() => handleQuizAnswer(q.id, option)}
                            />
                            <span>{option}</span>
                          </label>
                        ))}
                      </div>
                    </div>
                  ))}
                  <div className="button-group">
                    <button
                      onClick={handleQuizSubmit}
                      className="submit-btn"
                      disabled={Object.keys(quizAnswers).length < questions.length}
                    >
                      {language === "de" ? "Quiz abschließen" : "Complete Test"}
                    </button>
                    <button onClick={handleBack} className="back-btn">{language === "de" ? "Zurück" : "Back"}</button>
                  </div>
                </>
              )}
              {step === 5 && user && (
                <>
                  <h1>{language === "de" ? "Training erfolgreich abgeschlossen!" : "Training Successfully Completed!"}</h1>
                  <p>{language === "de" ? `Herzlichen Glückwunsch, ${user.name}! Ihr Abzeichen wird gedruckt.` : `Congratulations, ${user.name}! Your badge is being printed.`}</p>
                  <div className="sticker-preview">
                    <p><strong>{language === "de" ? "BASF VR-Sicherheitstraining" : "BASF VR Safety Training"}</strong></p>
                    <p>{language === "de" ? "Name" : "Name"}: {user.name}</p>
                    <p>{language === "de" ? "ID" : "ID"}: {user.id}</p>
                    <p>{language === "de" ? "Datum" : "Date"}: {new Date().toLocaleDateString()}</p>
                    <p>{language === "de" ? "Seriennummer" : "Serial Number"}: VR-{Math.floor(1000 + Math.random() * 9000)}</p>
                  </div>
                  <div className="button-group">
                    <button onClick={handlePrintBadge} className="submit-btn">{language === "de" ? "Abzeichen drucken" : "Print Badge"}</button>
                    <button onClick={handleBack} className="back-btn">{language === "de" ? "Zurück" : "Back"}</button>
                  </div>
                </>
              )}
            </div>
          )}
          <div className="progress-tracker">
            <h3>{language === "de" ? "Fortschritt" : "Progress"}</h3>
            {progressSteps.map((progStep, index) => (
              <div key={progStep.id} className="progress-step">
                <div className="progress-indicator">
                  <div className={`circle ${progStep.active.includes(step) ? "active" : step > progStep.active[progStep.active.length - 1] ? "completed" : ""}`}></div>
                  {index < progressSteps.length - 1 && <div className={`line ${step > progStep.active[progStep.active.length - 1] ? "completed" : ""}`}></div>}
                </div>
                <div className="progress-details">
                  <img src={progStep.icon} alt={`${progStep.name} icon`} className="step-icon" />
                  <p className="step-name">{progStep.name}</p>
                  <p className="step-description">{progStep.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </main>
    </div>
  );
};

export default TrainingApp;